import React, { useEffect, useState } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import axios from "axios";
import { getLocalStorageData } from "../utils/helpers/helpers";
import { API_URL } from "../components/network/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { post } from "../utils/helpers/http";
import Loader from "../Loader/Loader";
const Price = () => {
  const [prices, setPrices] = useState([]);
  const [title, setTitle] = useState("");
  const [lastEditedIndex, setLastEditedIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [disableAddButton, setDisableAddButton] = useState(false);
  const [disableUpdateButton, setDisableUpdateButton] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPrices();
  }, []);

  const fetchPrices = async () => {
    setLoader(true);
    try {
      const accessToken = getLocalStorageData("accessToken");
      const authorizationToken = getLocalStorageData("authorizationToken");
      const response = await axios.get(
        `${API_URL}/ManagePrice/GetPrices`,
        {
          headers: {
            UtcOffsetInSecond: 19800,
            AppVersion: 1,
            AccessToken: accessToken,
            Authorization: `Bearer ${authorizationToken}`,
          },
        }
      );
      if (Array.isArray(response.data.data)) {
        setPrices(response.data.data);
      } else {
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  const handlePriceChange = (index, value) => {
    if (!isNaN(value) && value >= 1 && value < 100000) {
      const newPrices = [...prices];
      newPrices[index].servicePrice = value;
      setPrices(newPrices);
      setLastEditedIndex(index);
    }
  };
  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  // const handleAddItem = async () => {
  //   if (title.trim() === "") {
  //     toast.error("Empty field is not allowed");
  //     return;
  //   }
  //   try {
  //     let body = {
  //       serviceTitle: toTitleCase(title),
  //       prices: 0,
  //       createdBy: 0,
  //       updatedBy: 0,
  //     };
  //     const response = await post('/ManagePrice/AddUpdatePrices', body);
  //     fetchPrices(response.data.data);
  //     toast.success("Item added successfully");
  //   } catch (error) {
  //   }
  // };
  // const handleDeleteService = async (id) => {
  //   setShowDeleteModal(true);
  //   setDeleteItemId(id);
  // };

  // const handleDeleteConfirmation = async () => {
  //   try {
  //     let body = { id: deleteItemId }
  //     const response = await post('/ManagePrice/DeleteServices', body)
  //     fetchPrices(response.data.data);
  //     toast.success("Item deleted successfully")
  //   } catch (error) {
  //   } finally {
  //     setShowDeleteModal(false);
  //   }
  // };
  const handleUpdatePrices = async () => {
    try {
      const servicePriceTableTypeList = prices.map(price => ({
        id: price.id,
        servicePrice: price.servicePrice
      }));


      if (servicePriceTableTypeList.some((price) => price.servicePrice === "" || price.servicePrice === null)) {
        toast.error("Price(s) can't be empty ");
        return;
      }
let body =  { servicePriceTableTypeList }
      const response = await post('/ManagePrice/UpdateAllPrices', body)
      console.log(response)
      toast.success("Item price updated successfully")
    } catch (error) {
    }
  };


  const handleClear = async () => {
    try {
      const accessToken = getLocalStorageData("accessToken");
      const authorizationToken = getLocalStorageData("authorizationToken");
      const response = await axios.get(
        `${API_URL}/ManagePrice/GetPrices`,
        {
          headers: {
            UtcOffsetInSecond: 19800,
            AppVersion: 1,
            AccessToken: accessToken,
            Authorization: `Bearer ${authorizationToken}`,
          },
        }
      );
      if (Array.isArray(response.data.data)) {
        setPrices(response.data.data);
      } else {
        setPrices([]);
      }
    } catch (error) {
      setPrices([]);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault(); // Prevent the default behavior of the backspace key
      const newPrices = [...prices];
      let newValue = newPrices[index].servicePrice !== null ? newPrices[index].servicePrice.toString() : "";
      newValue = newValue.slice(0, -1); // Remove the last digit
      newPrices[index].servicePrice = newValue === "" ? null : parseFloat(newValue);
      setPrices(newPrices);
      setLastEditedIndex(index);
    }
  };
  
  const handleKeyPress = (e) => {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 46 || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122)) {
      e.preventDefault();
    }
  };


  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth d-flex align-items-center justify-content-between flex-wrap">
                  <h1 className="page-title me-3">Manage Prices</h1>
                  {/* <div className="addtop d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control me-3"
                      placeholder="Enter title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      min={1}
                      max={99999}
                    />
                    <button className="btn btn-primary"
                     onClick={handleAddItem}
                     disabled={disableAddButton}
                     >
                      Add Item
                    </button>
                  </div> */}
                </div>
              </div>
              <div className="page-content">
                <div className="row">
                  {prices.map((price, index) => (
                    <div className="col-lg-3 col-md-6" key={price.id}>
                      <div className="lbag mb-3">
                        {/* {!price.isFixedFee && (
                          <div className="closethisbag" onClick={() => handleDeleteService(price.id)}></div>
                        )} */}
                    
                        <div className="form-group mb-0">
                          <label className="form-label">{price.serviceTitle}</label>
                          <div className="dollarsign">
                            <span>$</span>
                            {/* <input
                              type="number"
                              className="form-control"
                              value={price.servicePrice.toFixed(0)}
                              onChange={(e) => handlePriceChange(index, parseFloat(e.target.value))}
                            /> */}


<input
  type="number"
  className="form-control"
  value={price.servicePrice || ""}
  onChange={(e) => handlePriceChange(index, e.target.value)}
  onKeyDown={(e) => handleKeyDown(index, e)}
  onKeyPress={(e) => handleKeyPress(e)}
/>

                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4">
                {/* <button className="btn btn-default" onClick={handleClear}>
                    Clear
                  </button> */}

<button className="btn btn-default" onClick={handleClear}>
  Clear
</button>
                  <button className="btn btn-primary"
                   onClick={handleUpdatePrices}
                   disabled={disableUpdateButton}

                   >Update</button>
                </div>
              </div>
            </div>
            <ToastContainer
             position="top-right"
             autoClose={5000}
             hideProgressBar={false}
             closeOnClick
             pauseOnHover
             draggable
             onOpen={() => {
               setDisableAddButton(true);
               setDisableUpdateButton(true);
               setTimeout(() => {
                 setDisableAddButton(false);
                 setDisableUpdateButton(false);
               }, 5000);
             }}
             onClose={() => { }}
            />
          </div>
          {loader && <Loader/>}
          <Footer />
        </div>
      </div>
      {/* {showDeleteModal && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Item Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this item?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleDeleteConfirmation}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};
export default Price;